// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Each function does ONE thing
// 2. Separation of Concerns - Logic separated from presentation
// 3. Modular Architecture - Independent, reusable utilities
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

const STORAGE_KEY = 'nexus_login_remembered_credentials';

/**
 * Returns saved username/password when the user opted in via "Remember me".
 * Stored in localStorage (same XSS surface as auth_token). Use only with user consent.
 */
export function getSavedLoginCredentials() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (typeof data?.username !== 'string' || typeof data?.password !== 'string') {
      return null;
    }
    return { username: data.username, password: data.password };
  } catch {
    return null;
  }
}

export function saveLoginCredentials(username, password) {
  const payload = JSON.stringify({ username, password });
  localStorage.setItem(STORAGE_KEY, payload);
}

export function clearSavedLoginCredentials() {
  localStorage.removeItem(STORAGE_KEY);
}
